"use client";
import { egyptIcon, ksaIcon, kuwaitIcon, qatarIcon, uaeIcon } from "@/constants/icons";
import { languages, regions } from "@/i18n/routing";
import { getCountryCodeFromLocale, getLangFromLocale } from "@/utils/common";
// import Image from "next/image";
import { useParams, usePathname, useRouter } from "next/navigation";
import { useMemo } from "react";
import Select from "../ui/select/Select";
import { startPageTransition } from "@/apiUtils/pageLoadingUtils";

export const mapMap = {
  uae: uaeIcon,
  ksa: ksaIcon,
  qatar: qatarIcon,
  kuwait: kuwaitIcon,
  egypt: egyptIcon,
} as const;

const LocaleSelector = () => {
  const { locale } = useParams();
  const pathname = usePathname();
  const router = useRouter();
  const lang = useMemo(() => getLangFromLocale(locale as string), [locale]);
  const region = useMemo(() => getCountryCodeFromLocale(locale as string), [locale]);
  const filteredRegions = useMemo(() => {
    return regions.filter(
      (item) =>
        !(process?.env?.NEXT_PUBLIC_NON_NAVIGATIONAL_COUNTRIES?.split(",") || []).includes(
          item?.code,
        ),
    );
  }, [regions]);

  const handleChangeLanguage = (lang: string) => {
    const updatedPathname = pathname.replace(/([a-z]{2})(\/|$)/, `${lang}$2`);
    startPageTransition(true);
    // router.push(updatedPathname);
    window.location.replace(updatedPathname);
  };

  const handleChangeRegion = (region: string) => {
    // router.replace(`/${region}-${lang}`);
    window.location.replace(`/${region}-${lang}`);
  };

  return (
    <>
      <Select
        value={region}
        triggerProps={{ className: "w-full min-w-[9rem] border-[1px]" }}
        parentProps={{ className: "flex-1 " }}
        disabled={false}
        triggerLabel={lang === "ar" ? "اختر البلد" : "Select Country"}
        onChange={(_, val) => handleChangeRegion(val as string)}
        options={filteredRegions.map((item, index) => ({
          label: (
            <div className="flex flex-1 items-center justify-between">
              <span>{item.shortName}</span>
              <span className="border border-gray-200">
                <img
                  src={mapMap[item.shortName.toLowerCase() as keyof typeof mapMap]?.src}
                  alt={item.shortName}
                  className="h-3 w-5"
                />
              </span>
            </div>
          ),
          value: item.code,
        }))}
      />
      <Select
        value={lang}
        triggerProps={{ className: "w-full min-w-[9rem] border-[1px]" }}
        parentProps={{ className: "flex-1" }}
        triggerLabel="Select Language"
        onChange={(_, val) => handleChangeLanguage(val as string)}
        options={languages.map((item) => ({ label: item.name, value: item.code }))}
      />
    </>
  );
};

export default LocaleSelector;
